// | ------------------------------------------------------------------------
// | Components - Shop - Product Gallery
// | ------------------------------------------------------------------------ 


import Splide from '@splidejs/splide'; //? https://splidejs.com/
//import GLightbox from 'glightbox/dist/js/glightbox.js'; //? https://github.com/biati-digital/glightbox

import fsLightbox from 'fslightbox';

// | ------------------------------------------------------------------------ 


document.addEventListener( 'DOMContentLoaded', function () {

	var prodGallery = document.querySelector('.prod-main-carousel');

	if(prodGallery){
	
		var prodThumbs = new Splide( '.prod-thumbnails', {
			type: 'loop',
			gap: 10,
			perPage: 4,
			perMove: 1,
			cover: true,
			isNavigation: true,
			pagination: false,
		}).mount();
		
		var prodMainCarousel = new Splide( '.prod-main-carousel', {
			type       : 'fade',
			pagination : false,
			arrows     : false,
			cover      : true,
		});
		
		prodMainCarousel.sync( prodThumbs ).mount();
	
		// Light box
		//var lightbox = GLightbox({
		//	touchNavigation: true, 
		//	loop: true,
		//});	

	}

});

